




































































































































































































import {Component} from 'vue-property-decorator'
import {$} from '@/facade'
import OrbitLearnMoreModal from '@/components/orbit/OrbitLearnMoreModal.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component({
  components: {OrbitLearnMoreModal},
  computed: {
    $() {
      return $
    },
  },
})
export default class OrbitBanner extends MixinScreenSize {
  isLearnMoreModalVisible = false

  handleOpenOrbitLearnMoreModal() {
    this.isLearnMoreModalVisible = true
  }

  closeLearnMoreModal() {
    this.isLearnMoreModalVisible = false
  }
}
